module.exports = __webpack_public_path__ + "img/1400x100.2706b592.png";